export enum CampaignDurationEnum {
    MONTH_1 = 'month_1',
    MONTH_2 = 'month_2',
    MONTH_3 = 'month_3',
    MONTH_4 = 'month_4',
    MONTH_5 = 'month_5',
    MONTH_6 = 'month_6',
    MONTH_7 = 'month_7',
    MONTH_8 = 'month_8',
    MONTH_9 = 'month_9',
    MONTH_10 = 'month_10',
    MONTH_11 = 'month_11',
    MONTH_12 = 'month_12',
}
